import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
    MdDashboard, 
    MdBusinessCenter, 
    MdPeople, 
    MdAdd,
    MdViewList,
    MdSettings,
    MdLogout,
    MdPerson,
    MdMenu,
    MdChevronLeft,
    MdTrackChanges,
    MdClose,
    MdKeyboardArrowRight,
} from 'react-icons/md';
import { IoMdArrowDropdown } from 'react-icons/io';
// import './Sidebar.css';
import Cookies from 'js-cookie';

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [openDropdown, setOpenDropdown] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth <= 768) {
                setIsOpen(false);
            } else {
                setIsOpen(true);
            }
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const body = document.body;

        body.classList.toggle('sidebar-mobile', isMobile);
        body.classList.toggle('sidebar-open', !isMobile && isOpen);
        body.classList.toggle('sidebar-closed', !isMobile && !isOpen);

        return () => {
            body.classList.remove('sidebar-mobile', 'sidebar-open', 'sidebar-closed');
        };
    }, [isMobile, isOpen]);

    useEffect(() => {
        const handleToggleSidebar = () => {
            if (!isMobile) {
                setIsOpen(prev => !prev);
            }
        };

        window.addEventListener('toggle-sidebar', handleToggleSidebar);
        return () => window.removeEventListener('toggle-sidebar', handleToggleSidebar);
    }, [isMobile]);

    const handleDropdown = (menu) => {
        setOpenDropdown(openDropdown === menu ? '' : menu);
    };

    const handleLogout = () => {
        Cookies.remove('token');
        navigate('/login');
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const MenuItem = ({ icon: Icon, text, path, onClick, hasDropdown = false }) => (
        <div 
            className={`menu-item ${isActive(path) ? 'active' : ''}`}
            onClick={onClick}
        >
            <div className="menu-item-content">
                <Icon className="menu-icon" />
                <span className="menu-text">{text}</span>
                {hasDropdown && (
                    <IoMdArrowDropdown 
                        className={`dropdown-arrow ${openDropdown === text ? 'open' : ''}`}
                    />
                )}
            </div>
        </div>
    );

    const DropdownItem = ({ icon: Icon, text, path }) => (
        <Link to={path} className={`dropdown-item ${isActive(path) ? 'active' : ''}`}>
            <Icon className="dropdown-icon" />
            <span style={{marginLeft: '10px'}} className="dropdown-text">{text}</span>
        </Link>
    );

    // Mobile menu trigger
    const MobileMenuTrigger = () => (
        <button 
            className="mobile-menu-trigger"
            onClick={toggleSidebar}
            aria-label="Toggle menu"
        >
            <MdMenu />
        </button>
    );



    return (
        <>
            {isMobile && <MobileMenuTrigger />}
            
            <div className={`sidebar ${isOpen ? 'open' : 'closed'} ${isMobile ? 'mobile' : ''}`}>
                <div className="sidebar-header">
                    <div className="logo-container">
                        <img src="/celebration logo.png" alt="PMS" className="logo-img" />
                    </div>
                </div>

                <div className="sidebar-content">
                    <div className="menu-section">
                        <Link to="/employee/dashboard">
                            <MenuItem 
                                icon={MdDashboard}
                                text="Dashboard" 
                                path="/employee/dashboard"
                            />
                        </Link>
                    </div>

                    <div className="menu-section">
                        <MenuItem 
                            icon={MdBusinessCenter}
                            text="Key Result Areas" 
                            onClick={() => handleDropdown('Key Result Areas')}
                            hasDropdown
                        />
                        <div className={`dropdown ${openDropdown === 'Key Result Areas' ? 'show' : ''}`}>
                            <DropdownItem 
                                icon={MdAdd}
                                text="Add KRA" 
                                path="/employee/key-result-area/add"
                            />
                            <DropdownItem 
                                icon={MdViewList}
                                text="View KRAs" 
                                path="/employee/key-result-area/view"
                            />
                        </div>
                    </div>

                    <div className="menu-section">
                        <MenuItem 
                            icon={MdBusinessCenter}
                            text="KPIs" 
                            onClick={() => handleDropdown('Goals')}
                            hasDropdown
                        />
                        <div className={`dropdown ${openDropdown === 'Goals' ? 'show' : ''}`}>
                            <DropdownItem 
                                icon={MdAdd}
                                text="Create KPI" 
                                path="/employee/goal/add"
                            />
                            <DropdownItem 
                                icon={MdAdd}
                                text="Import KPIs" 
                                path="/employee/import-kpis"
                            />
                            <DropdownItem 
                                icon={MdViewList}
                                text="View KPIs" 
                                path="/employee/goals"
                            />
                        </div>
                    </div>
                    <div className="menu-section">

                        <Link to="/employee/goal-reviews">
                            <MenuItem 
                                icon={MdViewList}
                                text="Goal Reviews" 
                                path="/employee/goal-reviews"
                            />
                        </Link>
                    </div>
                    <div className="menu-section">
                        <MenuItem 
                            icon={MdBusinessCenter}
                            text="Improvement Plans" 
                            onClick={() => handleDropdown('IP')}
                            hasDropdown
                        />
                        <div className={`dropdown ${openDropdown === 'IP' ? 'show' : ''}`}>
                            <DropdownItem 
                                icon={MdAdd}
                                text="Create IP" 
                                path="/employee/create-improvement-plan"
                            />
                            {/* <DropdownItem 
                                icon={MdAdd}
                                text="Bulk KPIs" 
                                path="/employee/goals/add"
                            /> */}
                            <DropdownItem 
                                icon={MdViewList}
                                text="View IPs" 
                                path="/employee/improvement-plans"
                            />
                        </div>
                    </div>

                    

                    <div className="menu-divider"></div>

                    <div className="menu-section secondary-menu">

                        <Link to="/employee/change-password">
                            <MenuItem 
                                icon={MdSettings}
                                text="Change Password" 
                                path="/employee/change-password"
                            />
                        </Link>
                    </div>

                    <div className="menu-item logout" onClick={handleLogout}>
                        <div className="menu-item-content">
                            <MdLogout className="menu-icon" />
                            <span className="menu-text">Logout</span>
                        </div>
                    </div>
                </div>
            </div>
            
            {isMobile && isOpen && (
                <div className="sidebar-overlay" onClick={toggleSidebar}></div>
            )}
        </>
    );
};

export default Sidebar;
